import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';

import {Column} from './column';

export class StackedBar extends Column {
  constructor(chart: Chart,
              translate: TranslateService,
              localization: LocalizationService,
              public total: number) {
    super(chart, translate, localization);

    const columns: string[] = this.categories.map((column: string) => this.translate.instant(column));
    this.table = new KeyMetricsTable([], columns, this.categories, []);

    this.legend = {
      data: this.chart.data.map(item => item.category),
      formatter: (value) => this.translate.instant(value)
    };

    this.tooltip = this.getTooltipAxis();

    this.xAxis = [
      {
        type: 'value',
        axisLabel: {
          formatter: (value) => this.localization.localizeNumber(value, 'DECIMAL_2_DIGIT')
        }
      }
    ];

    this.yAxis = {
      type: 'category',
      data: this.categories
    };

    this.getPeriodAggregateData(this.categories).forEach((elementArray: number[], key: string) => {
      this.series.push({
        name: key,
        type: 'bar',
        stack: 'stack',
        itemStyle: {
          normal: {
            label: {
              show: true,
              formatter: this.getLabelFormatter()
            }
          }
        },
        data: elementArray
      });
      this.pushTableRow(key, elementArray);
    });
  }

  public pushTableRow(key: string, elementArray: number[]): void {
    this.table.addRowHeader(this.translate.instant(key));
    this.table.addData(elementArray
      .map((dataElement: number) => this.localization.localizeNumber(dataElement, 'DECIMAL_2_DIGIT'))
    );
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    this.createLoadViewDefault(withTitle, withLabel);
    if (withLabel) {
      this.series.forEach((value: any) => {
        value.itemStyle = {
          normal: {
            label: {
              show: true,
              formatter: this.getLabelFormatter()
            }
          }
        };
      });
    }
  }

  public getLabelFormatter(): (value) => string {
    return (value) => {
      return value.value && this.getPercent(value.value) > 7
        ? this.localization.localizeNumber(value.value, 'DECIMAL_2_DIGIT')
        : '';
    };
  }

  public resetChart(): void {
    this.resetDefault();
  }

  public getPercent(value: number): number {
    return value * 100 / this.total || 0;
  }
}
